import { render } from "./GivingDropdown.vue?vue&type=template&id=e46e6ee6"
import script from "./GivingDropdown.vue?vue&type=script&lang=js"
export * from "./GivingDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__